import api from './index'

const axios = require('axios')

export default {
    getBrief: () => {
        const path = '/sales/all/brief'

        return api.handling(axios.get(path))
    },

    getPaymentStats: () => {
        const path = '/sales/all/payment-stats'

        return api.handling(axios.get(path))
    },

    getComboChart: (type, date) => {
        const path = '/sales/all/combo-chart'

        return api.handling(axios.get(path, {
            params: {
                type: type,
                date: date
            }
        }))
    }
}
